export default __webpack_public_path__ + "static/media/apple-alt-white.e1719eba.svg";